import React from 'react';
import About from '../About/About';
import Contact from '../Contact/Contact';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import MySkills from '../MySkill/MySkills';
import Portfolio from '../Portfolio/Portfolio';
import Services from '../Services/Services';
import Hero from './Hero';

const Home = () => {
    return (
        <div>
            <Header />
            <Hero/>
            <About />
            <div
            style={{
                backgroundImage: "url('https://vproduction.com/wp-content/themes/vprod/assets/img/svg/menu-background.svg')",
        backgroundPosition: 'center',
        backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    
            }}
            >
            <MySkills/>
            <Services />
            </div>
            <Portfolio />
            <Contact />
            <Footer/>
        </div>
    );
};

export default Home;